import { Box, BoxProps } from "@chakra-ui/react";
import { FiCopy } from "react-icons/fi";

export const CopyIcon = (props: BoxProps) => {
  return <Box as={FiCopy} height="20px" width="20px" {...props} />;
};
